// src/app/services/event-bus.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface EventData {
  name: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class EventListenerService {
    private subject$ = new Subject<EventData>();

    emit(eventName: string, data?: any) {
        this.subject$.next({ name: eventName, data });
    }

    on(eventName: string, action: (data: any) => void) {
        return this.subject$.subscribe(event => {
        if (event.name === eventName) {
            action(event.data);
        }
        });
    }
}
